import { computed, ref, watch } from 'vue';
import { useUserStore } from './useStores';

export function useVerifyEmail() {
	const { loadInfo, userInfo, isLoggedIn, isAccountVerified } = useUserStore();

	const showBanner = ref(false);

	const userCreationTime = computed(() => userInfo.value.creationTime);

	watch(
		isLoggedIn,
		async () => {
			await loadInfo();

			if (!isLoggedIn.value || userInfo.value.emailVerified) {
				showBanner.value = false;
			}

			if (isLoggedIn.value && !isAccountVerified.value && !showBanner.value) {
				showBanner.value = true;
			}
		},
		{ immediate: true }
	);

	return {
		showBanner,
		userCreationTime,
	};
}
